<div class="pl-pane__container--horizontal">

  <header class="pl-page-header pl-pane--shrink">
    <div pl-grid="spaced tight align-middle">
      <div pl-grid-el pl-grid="1/2@phone">
        <h1 class="pl-heading--xlarge">{{ "USER.household" | translate }}</h1>
      </div>
    </div>
  </header>

  <div *ngIf="!loading" class="pl-pane--collapse pl-layout--on-gray">
    <app-duplicate-banner [personas]="personas" (onMerge)="refresh()"></app-duplicate-banner>
    <div class="pl-card__group">
      <div class="pl-card" [attr.aria-label]="persona.firstLastSuffix"
        *ngFor="let persona of personas">
        <span *ngIf="!persona.isSelf">
          <se-fe-icon-button [seFeMenuTrigger]="menuOptions[persona.id].name" seFeDataEmphasis="low" class="menuIcon">
            <se-fe-icon
              [seFeDataMargin]="false"
              seFeDataName="more"
              seFeDataSize="700"
              seFeDataColor="gray-700">
            </se-fe-icon>
          </se-fe-icon-button>
          <se-fe-menu
            seFeDataMaxHeight="255"
            seFeDataMinWidth="150"
            [seFeDataOptions]="menuOptions[persona.id]">
          </se-fe-menu>
        </span>
        <div class="pl-card-avatar">
          <div class="pl-card-avatar__no-background">
            <div class="pl-card-avatar__background-image"></div>
          </div>
          <div class="pl-card-avatar__image">
            <se-fe-avatar
              seFeDataType="persona"
              [seFeDataIdentity]="persona.fullName"
              [seFeDataImgUrl]="persona.cropImage || persona.originalImage"
              seFeDataSize="500">
            </se-fe-avatar>
          </div>
          <span *ngIf="persona.isSelf" class="pl-card-avatar__banner">
            {{ "PROFILE.RELATIONSHIP." + persona.persona_type | translate }}
          </span>
        </div>
        <div class="pl-card-detail__group">
          <div class="pl-card-detail--primary">
            {{ persona.firstLastSuffix }}
          </div>
          <div class="pl-card-detail--icon">
            <se-fe-icon class="pl-card-detail__icon" seFeDataName="phone_fill" seFeDataSize="200" seFeDataColor="gray-700" [seFeDataMargin]="false"></se-fe-icon>
            <p class="pl-card-detail__label">{{ "PERSONAS.phone" | translate }}</p>
            <p class="pl-card-detail__value--nowrap">
              <span *ngIf="persona.phone_numbers && persona.phone_numbers.length && persona.phone_numbers[0]?.number; else blankField">
                {{ persona.phone_numbers[0].number | phone }}
              </span>
            </p>
          </div>
          <div class="pl-card-detail--icon">
            <se-fe-icon class="pl-card-detail__icon" seFeDataName="envelope_filled" seFeDataSize="200" seFeDataColor="gray-700" [seFeDataMargin]="false"></se-fe-icon>
            <p class="pl-card-detail__label">{{ "PERSONAS.email" | translate }}</p>
            <p class="pl-card-detail__value--nowrap">
              <span *ngIf="persona.email_addresses && persona.email_addresses.length && persona.email_addresses[0]?.address; else blankField">
                {{ persona.email_addresses[0].address }}
              </span>
            </p>
          </div>
          <div class="pl-card-detail--icon">
            <a [routerLink]="['/user/profile', persona.id]" tabindex="-1">
              <se-fe-button seFeDataEmphasis="low">
                View Profile
              </se-fe-button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-profile-merge-modal [keepPersona]="keepPersona" [mergePersona]="mergePersona" description="from_modal" (successfulMerge)="onSuccessfulMerge()" #profileMergeModal></app-profile-merge-modal>
<app-profile-unclaim-modal (successfulDestroy)="removeUnlinkedPersona($event)" #profileUnclaimModal></app-profile-unclaim-modal>

<ng-template #blankField><span>--</span></ng-template>
